<script setup>
import { RouterView } from 'vue-router';

import { Spinner, Navbar, Sidebar } from '@/components/template';
import Alert from './components/Notifications/NotificationsList.ce.vue';
import { useAuthStore } from '@/stores';
const authStore = useAuthStore();
</script>

<template>
  <div>
    <Spinner />
    <Sidebar v-if="authStore.user"/>
    <div :class="authStore.user ? 'content' : 'container-xxl position-relative bg-white d-flex p-0'">
      <Navbar v-if="authStore.user"/>
      <Alert />
      <RouterView />
    </div>
  </div>
</template>

<style>
@import 'https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css';
@import "bootstrap/dist/css/bootstrap.min.css";
@import './assets/css/style.css';
@import 'https://use.fontawesome.com/releases/v5.2.0/css/all.css';
@import './assets/css/custom.css';
</style>
